import React, { useEffect, useState } from "react";
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Chip,
  useTheme,
  useMediaQuery,
  Select,
  MenuItem
} from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import {  Speed, Analytics, Refresh, Warning } from "@mui/icons-material";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import base_url from "../constants";
import Cookies from "js-cookie";

const filterOptions = [
  { label: "1 Day", value: "1d" },
  { label: "2 Day", value: "2d" },
  { label: "3 Day", value: "3d" },
  { label: "4 Day", value: "4d" },
  { label: "5 Day", value: "5d" },
  { label: "6 Day", value: "6d" },
  { label: "7 Day", value: "7d" },
];



const WhatsappMessageSpeedChart = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [messages, setMessages] = useState([]);
  const [labels, setLabels] = useState([]);
  const [filter, setFilter] = useState("1d");
  const [totalMsg, setTotalMsg] = useState(0);

// const fetchMessageSpeed = async () => {
//   try {
//     const userId = Cookies.get("userId");
//     const res = await axios.get(
//       base_url + `/whatsapp_message_speed/user?user_id=${userId}&filter=${filter}`
//     );

//     const serverData = res.data?.data || [];
//     setTotalMsg(res.data?.total_messages || 0);

//     // Create full date list based on selected filter
//     const daysCount = parseInt(filter.replace("d", ""));
//     const fullDates = Array.from({ length: daysCount }, (_, i) => {
//       const d = new Date();
//       d.setDate(d.getDate() - i);
//       return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
//     }).reverse();

//     // Generate 48 slots (30 min each)
//     const fullTimeSlots = [];
//     for (let hour = 0; hour < 24; hour++) {
//       fullTimeSlots.push(`${hour.toString().padStart(2, "0")}:00-${hour.toString().padStart(2, "0")}:30`);
//       fullTimeSlots.push(`${hour.toString().padStart(2, "0")}:30-${(hour + 1).toString().padStart(2, "0")}:00`);
//     }

//     // Build grouped structure
//     const grouped = {};
//     fullDates.forEach(date => {
//       fullTimeSlots.forEach(slot => {
//         const label = `${date}\n${slot}`;
//         grouped[label] = {}; // ANY message type
//       });
//     });

//     // Detect all message types dynamically
//     const messageTypes = new Set();

//     serverData.forEach(item => {
//       const date = new Date(item.date).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });

// const startHour = item.hour.toString().padStart(2, "0");
// const startMin = item.interval_block === 0 ? "00" : "30";

// const endHour = item.interval_block === 0
//   ? startHour
//   : ((item.hour + 1) % 24).toString().padStart(2, "0");

// const endMin = item.interval_block === 0 ? "30" : "00";

//       const label = `${date}\n${startHour}:${startMin}-${endHour}:${endMin}`;

//       messageTypes.add(item.status);

//       if (!grouped[label][item.status]) {
//         grouped[label][item.status] = 0;
//       }
//       grouped[label][item.status] += item.total_messages;
//     });

//     const labels = Object.keys(grouped);

//    // Build dynamic series data
//     const formattedMessages = {};
//     messageTypes.forEach(type => {
//       formattedMessages[type] = labels.map(l => grouped[l][type] || 0);
//     });

//     // Combine all message types into a single SENT series
//     const combinedMessages =
//       labels.map((_, i) =>
//         Object.keys(formattedMessages)
//           .reduce((sum, key) => sum + (formattedMessages[key][i] || 0), 0)
//       );

//     setLabels(labels);
//     setMessages({ SENT: combinedMessages });


//   } catch (err) {
//     console.error("API Error:", err);
//   }
// };

const fetchMessageSpeed = async () => {
  try {
    const userId = Cookies.get("userId");
    const res = await axios.get(
      base_url + `/whatsapp_message_speed/user?user_id=${userId}&filter=${filter}`
    );

    const serverData = res.data?.data || [];
    setTotalMsg(res.data?.total_messages || 0);

    // --------------------------
    // 1. Determine timeline length
    // --------------------------
    const days = parseInt(filter.replace("d", ""));
    const totalSlots = days * 48; // 48 slots per day (30 min each)

    // --------------------------
    // 2. Build rolling timeline *backwards*
    // --------------------------
    const now = new Date();
    const timelineLabels = [];
    const timelineKeys = []; // for matching

    for (let i = totalSlots - 1; i >= 0; i--) {
      const slotStart = new Date(now.getTime() - i * 30 * 60 * 1000);
      const slotEnd = new Date(slotStart.getTime() + 30 * 60 * 1000);

      const label =
        slotStart.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
        }) +
        "\n" +
        slotStart.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }) +
        "-" +
        slotEnd.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });

      timelineLabels.push(label);

      timelineKeys.push({
        start: slotStart,
        end: slotEnd,
      });
    }

    // --------------------------
    // 3. Prepare data array (all zeros)
    // --------------------------
    const combinedMessages = new Array(totalSlots).fill(0);

    // --------------------------
    // 4. Insert server data into correct time slots
    // --------------------------
    serverData.forEach((item) => {
      const eventDate = new Date(
        item.date + " " + item.hour.toString().padStart(2, "0") + ":" +
        (item.interval_block === 0 ? "00" : "30")
      );

      // Find correct slot index
      for (let i = 0; i < totalSlots; i++) {
        if (eventDate >= timelineKeys[i].start && eventDate < timelineKeys[i].end) {
          combinedMessages[i] += item.total_messages;
          break;
        }
      }
    });

    // Save state
    setLabels(timelineLabels);
    setMessages({ SENT: combinedMessages });

  } catch (err) {
    console.error("API Error:", err);
  }
};


  useEffect(() => {
    fetchMessageSpeed();
  }, [filter]);


  // Primary color from theme
  const primaryColor = theme.palette.primary.main;

  return (
    <Box sx={{ maxWidth: 1200, margin: "auto", mt: 4, px: 2 }}>
      {/* Header Section */}
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Typography 
          variant="h4" 
          fontWeight="bold" 
          color="primary"
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",
            gap: 2,
            mb: 1
          }}
        >
          <Analytics fontSize="large" />
          Whatsapp Message Analytics Dashboard
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Real-time message speed monitoring and analysis
        </Typography>
      </Box>

    {/* Statistics Cards */}
      <Box sx={{ 
        display: "grid", 
        gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
        gap: 3, 
        mb: 4 
      }}>
        {/* Total Messages Card */}
        <Card 
          sx={{ 
            background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor} 100%)`,
            color: "white",
            borderRadius: 3,
            boxShadow: `0 8px 32px ${primaryColor}40`
          }}
        >
          <CardContent sx={{ textAlign: "center", p: 1.5 }}>  {/* ↓ reduced padding */}
            <Speed sx={{ fontSize: 32, mb: 0.5 }} />          {/* ↓ smaller icon */}
            <Typography variant="h7" fontWeight="bold">       {/* ↓ smaller text */}
              {totalMsg|| 0}
            </Typography>
            <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
              Total Sent Messages
            </Typography>
          </CardContent>
        </Card>
      </Box>


      {/* Main Chart Card */}
      <Card 
        sx={{ 
          borderRadius: 3,
          boxShadow: `0 12px 40px ${theme.palette.grey[200]}`,
          border: `1px solid ${theme.palette.grey[200]}`,
          overflow: "hidden"
        }}
      >
        <CardContent sx={{ p: 4 }}>
          {/* Chart Header */}
          <Box sx={{ 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center", 
            mb: 4,
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 2 : 0
          }}>
            <Box>
              <Typography 
                variant="h5" 
                fontWeight="bold" 
                color="primary"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <Speed />
               Whatsapp Message Speed Analytics
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Last 30 minutes intervals - Real-time monitoring
              </Typography>
            </Box>
            
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
               <Select
                sx={{
                  height: 32,             // overall height
                  "& .MuiSelect-select": {
                    padding: "4px 14px",  // reduce inner padding
                  },
                }}
                size="small" value={filter} onChange={(e) => setFilter(e.target.value)}>
                {filterOptions.map((f) => (
                  <MenuItem value={f.value} key={f.value}>
                    {f.label}
                  </MenuItem>
                ))}
              </Select>
              <Chip 
                label="Refresh" 
                color="primary" 
                variant="filled"
                size="small"
                icon={<Refresh />}
                onClick={() => {
                  fetchMessageSpeed()
                  setFilter("1d")}
                }   
              />
            </Box>
          </Box>

          {/* Chart */}
          <Box sx={{ height: 400 }}>
          {labels.length > 0 ? (
            <BarChart
              xAxis={[
                {
                  id: "timeSlots",
                  data: labels,
                  scaleType: "band",
                  tickLabelStyle: { whiteSpace: "pre" },
                  // label:"Date & Time Interval",
                  labelStyle: {
                    fontSize: 12,
                    fontWeight: "bold",
                    fill: theme.palette.text.primary
                  }
                },
              ]}
              yAxis={[
                {
                  tickMinStep: 1,  
                  min: 0, 
                  label: "Number of Messages",
                  minPadding: 5,  
                  maxPadding: 10,
                  labelStyle: {
                    fontSize: 12,
                    fontWeight: "bold",
                    fill: theme.palette.text.primary
                  },
                max:
                Object.keys(messages).length > 0
                  ? Math.max(
                      ...Object.values(messages)
                        .flat()
                    ) + 2
                  : 10,
                }
              ]}
              series={Object.keys(messages).map((type, index) => ({
                  data: messages.SENT,
                  label: "SENT",
                  stack: "msg",
                  color: primaryColor
              }))}

              height={400}
              margin={{ left: 70, right: 30, top: 30, bottom: 70 }}
              grid={{ vertical: true, horizontal: true }}
              borderRadius={8}
              sx={{
                '& .MuiChartsAxis-tickLabel': {
                  fontSize: '12px',
                  fontWeight: '500',
                },
                '& .MuiChartsAxis-line': {
                  stroke: theme.palette.grey[300],
                },
                '& .MuiChartsGrid-line': {
                  stroke: theme.palette.grey[100],
                },
              }}
            />
             ) : (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: theme.palette.text.secondary,
                fontSize: 18,
              }}
            >
              No Data Available
            </Box>
          )}
          </Box>

          {/* Chart Footer */}
          <Box sx={{ 
            mt: 3, 
            pt: 2, 
            borderTop: `1px solid ${theme.palette.grey[200]}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 2 : 0
          }}>
            <Typography variant="body2" color="text.secondary">
              {/* Last updated: {new Date().toLocaleTimeString()} */}
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Chip 
                label={`Total: ${totalMsg} messages sent`} 
                size="small"
                color="primary"
                variant="outlined"
              />
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Info Section */}
      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          Monitoring message throughput across 30-minute intervals for optimal performance analysis
        </Typography>
      </Box>
    </Box>
  );
};

export default WhatsappMessageSpeedChart;